type Props = {
  currentQuestion: any;
};

const AddressField = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;

  if (!properties) return null;

  const fields = [
    { key: "zipcode", label: "Zip Code" },
    { key: "city", label: "City" },
    { key: "state", label: "State" },
    { key: "country", label: "Country" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {fields.map(
        (field) =>
          properties[field.key] && (
            <div
              key={field.key}
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <span style={{ fontWeight: 500, minWidth: "80px" }}>
                {field.label}:
              </span>

              <input
                type="text"
                style={{
                  width: "200px",
                  height: "35px",
                  padding: "4px 8px",
                }}
              />
            </div>
          )
      )}
    </div>
  );
};

export default AddressField;
